export const ENFORCE_2FA = 'ENFORCE_2FA'

export default {
    list: ENFORCE_2FA,
}
